<!--
@Create By Tim For 19/08/13
@最新课程组件
-->
<template>
  <div class="NewCourse">
    <el-row :gutter="20">
      <el-col :span="4" v-for="(item, index) in newCourseList" :key="index">
        <a href="javascript:;" @click="goToInfo(item)">
          <el-card class="box-card" shadow="hover">
            <div class="cardImg">
              <el-image fit="fill" :lazy="true" style="width:221px;height:140px;" :src="item.coursePicUrl">
                <div slot="placeholder" class="placeholder">封面加载中...</div>
              </el-image>
            </div>
            <p class="title">{{ item.courseName }}</p>
            <p class="tip">{{ grade(item.courseGrade) }} | {{ item.chapterCount }}节课</p>
          </el-card>
        </a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../../../config/api';

export default {
  name: 'NewCourse',
  data() {
    return {
      // 最新课程集合
      newCourseList: []
    };
  },

  created() {
    this.getData();
  },

  methods: {
    // 获取最新课程数据
    getData() {
      this.$axios.get(api + 'portal/course/list?pageNum=1&pageSize=6').then(res => {
        if (res) {
          this.newCourseList = res.rows;
        }
      });
    },

    // 过滤课程级别
    grade(data) {
      if (data == 1) {
        return '初级';
      } else if (data == 2 || data == 3) {
        return '中级';
      } else if (data == 4 || data == 5) {
        return '高级';
      }
    },

    // 进入详情页
    goToInfo(data) {
      this.$router.push({ path: '/CourseInfo/' + data.id });
    }
  }
};
</script>
<style>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 6px;
}

.NewCourse .el-card__body {
  padding: 0;
}
</style>

<style scoped>
.NewCourse {
  width: 1440px;
  margin: 0 auto;
}

.NewCourse .box-card {
  margin-bottom: 20px;
}

.NewCourse .cardImg {
  width: 221px;
  height: 140px;
}

.NewCourse .title {
  width: 211px;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.NewCourse .tip {
  width: 211px;
  height: 20px;
  padding: 0 5px;
  line-height: 20px;
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
}

.NewCourse .placeholder {
  width: 221px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

.NewCourse a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/NewCourse.vue